const VERSION = "7.0.5";
export {
  VERSION
};
